<template>
  <div class="d-flex">
    <v-btn
      class="mr-2 pa-2 rounded-circle d-inline-block"
      min-width="20px"
      height="20px"
      color="grey"
      depressed
      :class="{ 'mb-4': type === 'start', 'mb-1': type === 'end' }"
    />
    <div class="text--secondary">{{ title }}</div>
  </div>
</template>
<script>
export default {
  props: {
    direction: String,
    type: String
  },
  computed: {
    title() {
      if (this.direction === 'in') {
        if (this.type === 'start') return 'Xuất phát'
        return 'Đến trường'
      }
      if (this.type === 'start') return 'Từ trường'
      return 'Kết thúc'
    }
  }
}
</script>
